<template>
  <DefScrollbar class="modal-aside-body">
    <slot />
  </DefScrollbar>
</template>

<script lang="ts" setup>
import DefScrollbar from '@components/Def/DefScrollbar/DefScrollbar.vue';
</script>

<style lang="scss" scoped>
.modal-aside-body {
  scrollbar-gutter: stable;
  padding: 16px;
  flex: 1 1 auto;
  @include point-md {
    padding: 24px 10px 24px 24px;
  }
}
</style>
